import React from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import FilterAZIcon from '../../../../../assets/images/filter/FilterAZIcon';
import FilterZAIcon from '../../../../../assets/images/filter/FilterZAIcon';
import { useTranslation } from 'react-i18next';
import tPaths from '../../../../../utils/tPaths';

interface IFilterFooterProps {
  styles: Record<string, any>;
  sortingAsc: boolean;
  handleClickSorting: () => void;
  onClickFilterButton: () => void;
}

const Footer: React.FC<IFilterFooterProps> = ({ styles, handleClickSorting, sortingAsc, onClickFilterButton }) => {
  const {t} = useTranslation()
  return (
    <Grid className={styles.footer}>
      <Box className={styles.footerIcon} onClick={handleClickSorting}>
        {sortingAsc ? <FilterAZIcon /> : <FilterZAIcon />}
      </Box>

      <Button className={styles.footerButton} variant="contained" color="primary" onClick={onClickFilterButton}>
        {t(tPaths.table.filter)}
      </Button>
    </Grid>
  );
};

export default Footer;
